import { render, staticRenderFns } from "./NewMidwife.vue?vue&type=template&id=34a47055"
import script from "./NewMidwife.vue?vue&type=script&lang=js"
export * from "./NewMidwife.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports